export const pickI18nString = (
  i18nJson: any,
  base: string | null | undefined,
  lang: string,
  fallbackLang?: string
): string => {
  // Coerce various JSONB representations into a flat { [lang]: string } map
  let map: Record<string, string> = {};
  if (typeof i18nJson === 'string') {
    try {
      const parsed = JSON.parse(i18nJson);
      if (parsed && typeof parsed === 'object') map = parsed as Record<string, string>;
    } catch {
      // ignore
    }
  } else if (i18nJson && typeof i18nJson === 'object' && !Array.isArray(i18nJson)) {
    map = i18nJson as Record<string, string>;
  }

  const norm = (code: string | undefined) => (code || '').toLowerCase().split('-')[0];
  const l = norm(lang);
  const f = norm(fallbackLang);
  return (
    (l && map[l]) ||
    (f && map[f]) ||
    (base || '')
  );
};

export const pickI18nValue = <T = any>(
  i18nJson: any,
  lang: string,
  fallbackLang?: string
): T | undefined => {
  // Supports JSONB stored as object or JSON string
  let map: Record<string, T> = {} as Record<string, T>;
  if (!i18nJson) return undefined;
  if (typeof i18nJson === 'string') {
    try {
      const parsed = JSON.parse(i18nJson);
      if (parsed && typeof parsed === 'object') map = parsed as Record<string, T>;
    } catch {
      return undefined;
    }
  } else if (typeof i18nJson === 'object' && !Array.isArray(i18nJson)) {
    map = i18nJson as Record<string, T>;
  }
  const norm = (code: string | undefined) => (code || '').toLowerCase().split('-')[0];
  const l = norm(lang);
  const f = norm(fallbackLang);
  return (l && map[l]) || (f && map[f]) || undefined;
};
